// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__nxINk","row":"styles_row__2A_Po"};